/** Maps to TalentToolbox.Forms.Core.Enums.ClientFormAutomationUnit */
export enum ClientFormAutomationUnitEnum {
  Years,
  Months,
  Weeks,
  Days
}

export default ClientFormAutomationUnitEnum;
